export default {
  index: ({anchor = undefined} = {}) => {
    return `/${anchor ? `#${anchor}` : ""}`;
  },
  xavin: () => {
    return "/xavin";
  },
  signIn: () => {
    return "/sign-in";
  },
  signUp: () => {
    return "/sign-up";
  },
  registration: () => {
    return "/registration";
  },
  completeRegistration: () => {
    return  "/complete-registration";
  },
  forgotPassword: () => {
    return "/forgot-password";
  },
  resetPassword: () => {
    return "/reset-password";
  },
  project: (project = undefined) => {
    // TODO: lookup xavin base url from env
    const fallbackUrl = "https://www.xavin.eu/projekte"
    if (project && typeof project === 'object' && project.xavinUrl) {
      return project.xavinUrl;
    } else {
      return fallbackUrl;
    }
  },
  invest: (project = undefined) => {
    let identifier = ":identifier";
    if(project) {
      if(typeof project === 'string') {
        identifier = project;
      }
      else {
        identifier = project.slug;
      }
    }
    if (!identifier)
      return '/projects';
    return `/invest/${identifier}`;
  },
  confirm_investment: (token = undefined) => {
    let identifier = ":identifier";
    if(token) {
      if(typeof token === 'string') {
        identifier = token;
      }
    }
    if (!identifier)
      return '/projects';
    return `/confirm_investment/${identifier}`;
  },
  profile: () => {
    return "/profile";
  },
  profilePersonalInfo: () => {
    return "/profile/personal-info";
  },
  profileQuestionnaire: () => {
    return "/profile/questionnaire";
  },
  profilePaymentMethod: () => {
    return "/profile/payment-method";
  },
  profileIdentify: () => {
    return "/profile/identify";
  },
  profileIdentificationSuccess: () => {
    return "/profile/identification-success";
  },
  investment: (investment = undefined) => {
    let identifier = ":identifier";
    if(investment) {
      if(typeof project === 'string') {
        identifier = investment;
      }
      else {
        identifier = investment.code;
      }
    }
    return `/investments/${identifier}`;
  },
  page: (item = undefined) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.slug;
      }
    }
    return `/${identifier}`;
  },
  downloadable: (item = undefined) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.slug;
      }
    }
    return `/downloadables/${identifier}`;
  },
  aboutUs: () => {
    return "/uber-uns";
  },
  imprint: () => {
    return "/impressum";
  },
  howItWorks: () => {
    return "/so-funktionierts";
  },
  termsAndConditions: () => {
    return "/agb";
  },
  dataProtection: () => {
    return "/datenschutz";
  },
  becomeAPartner: () => {
    return "/projektentwickler"
  },
  contacts: () => {
    return "/kontakt"
  },
  riskWarning: () => {
    return "/risikohinweise"
  },
  mandatoryInformation: () => {
    return "/pflichtangaben"
  },
  faq: () => {
    return "/faq"
  },
  press: () => {
    return "/media"
  },
  facebook: () => {
    return "https://www.facebook.com/xavin.eu/"
  },
  instagram: () => {
    return "https://www.instagram.com/xavin.eu/"
  },
  linkedIn: () => {
    return "https://www.linkedin.com/company/xavin-gmbh/"
  },
  pageNotFound: () => {
    return "/page-not-found"
  },
  thankYouPage: () => {
    return "/thank-you"
  }
}
